// Polyfills

// Prefer CoreJS over the polyfills above
import 'core-js/es6';
import 'core-js/es7/reflect';
require('zone.js/dist/zone');

// Typescript emit helpers polyfill
import 'ts-helpers';

// polyfill for IE and Safari
(function (ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT['mozMatchesSelector'] || ELEMENT.msMatchesSelector || ELEMENT['oMatchesSelector'] || ELEMENT.webkitMatchesSelector;
    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
            if (!this) return null;
            if (this.matches(selector)) return this;
            if (!this.parentElement) {
                return null
            }
            else return this.parentElement.closest(selector)
        };
}(Element.prototype));


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/polyfills.ts